import * as types from './types';

export const doPreLogin = (email, ssoConfig) => ({
  type: types.DO_PRE_LOGIN,
  payload: {
    email,
    ssoConfig,
  },
});

export const doPreLogout = () => ({
  type: types.DO_PRE_LOGOUT,
});

export const authError = (errorMsg) => ({
  type: types.AUTH_ERROR,
  payload: {
    errorMsg,
  },
});

export const clearAuthError = () => ({
  type: types.CLEAR_AUTH_ERROR,
});
